<template>
    <div class="ios-tab-pane">
        <v-row class="grc-body">
            <!-- Nueva sección: Documentos del Portal (Full Width encima de todas las columnas) -->
            <v-col cols="12" v-if="orderLocal.PurchaseFiles && orderLocal.PurchaseFiles.length > 0" class="pt-0 pb-1">
                <div class="portal-docs-section">
                    <div class="portal-docs-header mb-2">
                        <v-icon small color="primary" class="mr-1">mdi-folder-google-drive</v-icon>
                        <span class="portal-docs-title">Documentos Adjuntos del Portal</span>
                    </div>
                    <div class="portal-docs-list portal-docs-grid">
                        <div v-for="file in orderLocal.PurchaseFiles" :key="file.FilID" class="portal-doc-card">
                            <div class="portal-doc-main">
                                <div class="portal-doc-info">
                                    <div class="portal-doc-type">{{ getAttachmentTitle(file.AttachmentIndex) }}</div>
                                    <div class="portal-doc-name text-truncate" :title="file.FilName">{{ file.FilName }}
                                    </div>
                                    <div class="portal-doc-date mt-1 d-flex align-center" v-if="file.SecCreate">
                                        <v-icon size="12" class="mr-1" color="grey darken-1">mdi-calendar-clock</v-icon>
                                        <span class="grey--text text--darken-2"
                                            style="font-size: 10px; font-weight: 500;">
                                            {{ $fun.formatDateView(file.SecCreate) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="portal-doc-actions-status">
                                    <!-- Badges based on status -->
                                    <v-chip x-small dense class="mr-2"
                                        :color="file.FilStatus == 1 ? 'warning' : (file.FilStatus == 2 ? 'success' : 'error')"
                                        dark>
                                        {{ file.FilStatus == 1 ? 'Pendiente' : (file.FilStatus == 2 ? 'Aprobado' :
                                            'Rechazado') }}
                                    </v-chip>

                                    <!-- Download Button -->
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn icon x-small color="primary" class="conformity-icon-btn"
                                                v-bind="attrs" v-on="on"
                                                @click.prevent="downloadPortalFile(file.FilName)">
                                                <v-icon size="18">mdi-download</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Descargar</span>
                                    </v-tooltip>

                                    <!-- Approve / Disapprove options (Only if status is 1 - Pending) -->
                                    <template v-if="file.FilStatus == 1">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon x-small class="conformity-icon-btn ml-1" color="success"
                                                    v-bind="attrs" v-on="on" @click.prevent="approvePortalFile(file)">
                                                    <v-icon size="18">mdi-thumb-up</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Aprobar</span>
                                        </v-tooltip>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon x-small class="conformity-icon-btn ml-1"
                                                    :color="activeDisapprovalFileId === file.FilID ? 'error' : 'grey darken-1'"
                                                    v-bind="attrs" v-on="on"
                                                    @click.prevent="toggleDisapprovePortalFile(file)">
                                                    <v-icon size="18">mdi-thumb-down</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Desaprobar</span>
                                        </v-tooltip>
                                    </template>
                                </div>
                            </div>

                            <!-- Mensaje de estado Aprobado/Rechazado (si FilStatus !== 1) -->
                            <template v-if="file.FilStatus != 1">
                                <div class="portal-doc-feedback-msg mt-2">
                                    <template v-if="file.FilStatus == 2">
                                        <div class="approved-feedback-wrap d-flex align-center">
                                            <v-icon x-small color="success" class="mr-1">mdi-check-decagram</v-icon>
                                            <span class="feedback-text font-weight-bold">Aprobado exitosamente para
                                                conformidad.</span>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div class="rejected-feedback-wrap d-flex align-start">
                                            <v-icon x-small color="error" class="mr-1 mt-1">mdi-alert-decagram</v-icon>
                                            <span class="feedback-text">
                                                <strong>Desaprobado:</strong>
                                                {{ file.FilObservation || 'Sin observaciones.' }}
                                            </span>
                                        </div>
                                    </template>
                                </div>
                            </template>

                            <!-- Textarea for disapproval (If this file is currently being disapproved) -->
                            <v-expand-transition>
                                <div v-if="activeDisapprovalFileId === file.FilID"
                                    class="portal-doc-disapprove-input mt-2">
                                    <v-textarea v-model="disapprovalComment" outlined dense rows="1" auto-grow
                                        hide-details placeholder="Escriba el motivo de desaprobación..."
                                        class="grc-field rounded-lg conformity-textarea"></v-textarea>
                                    <v-btn block color="error" class="mt-1 rounded-lg text-none"
                                        :disabled="!disapprovalComment || !disapprovalComment.trim()"
                                        @click="confirmPortalFileDisapproval(file)">
                                        Confirmar Desaprobación
                                    </v-btn>
                                </div>
                            </v-expand-transition>
                        </div>
                    </div>
                </div>
            </v-col>

            <v-col cols="9" class="grc-col-table">
                <div class="grc-header"
                    v-if="getLinesDeliveryNotesAvailablesToInvoices.length > 0 && orderLocal.CANCELED == 'N'">
                    <div class="grc-header-left">
                        <v-icon class="grc-header-icon" color="white" size="28">mdi-receipt-text-check</v-icon>
                        <span class="grc-header-title">Generar Factura Proveedor</span>
                    </div>
                    <div class="grc-header-right">
                        <span class="grc-selected-label">
                            {{ (orderLocal.TypeOrder == 1)
                                ? invoiceSelectedDeliveryNotes.length :
                                invoiceSelectedServiceItems.length }}
                            / {{ getLinesDeliveryNotesAvailablesToInvoices.length }}
                            ítem(s) seleccionado(s)
                        </span>
                    </div>
                </div>

                <!-- Entradas de mercancia por Facturar -->
                <v-data-table
                    v-if="orderLocal.TypeOrder == 1 && getLinesDeliveryNotesAvailablesToInvoices.length > 0 && orderLocal.CANCELED == 'N'"
                    dense :headers="getHeadersTableGenerateInvoice" :items="getLinesDeliveryNotesAvailablesToInvoices"
                    item-key="uniqueId" v-model="invoiceSelectedDeliveryNotes" show-select hide-default-footer
                    :items-per-page="-1" class="grc-table mt-2"
                    :class="getLinesSummaryPurchaseInvoices.length > 0 ? 'mb-5' : ''">
                    <template v-slot:item.Description="{ item }">
                        <div class="product-cell">
                            <div class="product-desc" :title="item.Description">
                                {{ item.Description }}
                            </div>
                            <span class="product-code">{{ item.ItemCode }}</span>
                        </div>
                    </template>
                    <template v-slot:item.Quantity="{ item }">
                        <div class="qty-container text-center">
                            {{ item.Quantity }} {{ item.UnitMsr }}
                        </div>
                    </template>
                    <template v-slot:item.BaseQty="{ item }">
                        <div class="qty-container text-center">
                            <span class="qty-value">{{ item.BaseQty }} {{ item.UnitMsr }}</span>
                        </div>
                    </template>
                </v-data-table>

                <!-- Items de los servicios a Facturar -->
                <v-data-table
                    v-else-if="orderLocal.TypeOrder == 3 && getLinesDeliveryNotesAvailablesToInvoices.length > 0 && orderLocal.CANCELED == 'N'"
                    dense :headers="getHeadersTableGenerateInvoice" :items="getServicesAvailablesToInvoices"
                    item-key="LineNumSap" @toggle-select-all="onSelectAllServiceToInvoice"
                    @item-selected="onServiceItemSelected" v-model="invoiceSelectedServiceItems" show-select
                    hide-default-footer :items-per-page="-1" class="grc-table mt-2"
                    :class="getServicesAvailablesToInvoices.length > 0 ? 'mb-5' : ''">

                    <template v-slot:item.OddDescription="{ item }">
                        <div class="product-cell">
                            <div class="product-desc" :title="item.OddDescription">
                                {{ item.OddDescription }}
                            </div>
                        </div>
                    </template>

                    <template v-slot:item.OddUnitPrice="{ item }">
                        {{ item.TypeCurrencyName }} {{ item.OddUnitPrice }}
                    </template>
                    <template v-slot:item.OddTaxAmount="{ item }">
                        {{ item.TypeCurrencyName }} {{ item.OddTaxAmount }}
                    </template>

                    <template v-slot:item.OddDiscountPercentage="{ item }">
                        <div class="text-center font-weight-medium">
                            {{ item.OddDiscountPercentage }} % ({{ item.OddDiscount }})
                        </div>
                    </template>

                    <template v-slot:item.OddAmount="{ item }">
                        <div
                            :class="parseFloat(item.OddDiscount) > 0 ? 'text-decoration-line-through red--text' : 'font-weight-bold green--text'">
                            {{ (item.OddAmount + item.OddDiscount).toFixed(2) }}
                        </div>

                        <div v-if="parseFloat(item.OddDiscount) > 0"
                            class="grc-qty-chip font-weight-bold text-center green--text">
                            {{ (item.OddAmount).toFixed(2) }}
                        </div>

                        <div v-if="itemServiceInvoiceIsSelected(item)">
                            <v-text-field v-model.number="item.OddAmountInvoice" type="number" dense outlined
                                hide-details :min="0" :max="item.OddAmount"
                                :disabled="!itemServiceInvoiceIsSelected(item)"
                                :error="item.OddAmountInvoice > item.OddAmount" style="width:90px;"
                                class="grc-qty-input rounded-lg" @input="onServiceAmountInvoiceInput(item)"
                                @blur="onServiceAmountInvoiceBlur(item)" />
                        </div>
                    </template>

                    <template v-slot:item.OddQuantity="{ item }">
                        <v-chip small label outlined color="grey" class="grc-qty-chip pa-3 px-5 rounded-lg">
                            {{ item.OddQuantity }} {{ item.UnitMeasurement }}
                        </v-chip>
                    </template>
                    <template v-slot:item.TotalPayment="{ item }">
                        {{ item.TotalPayment.toFixed(2) }}
                    </template>
                </v-data-table>

                <!-- SECCIÓN DE ACTIVIDADES DE ORDEN DE SERVICIO (TypeOrder == 3) -->
                <div v-if="orderLocal.TypeOrder == 3 && activitiesList.length > 0 && orderLocal.CANCELED == 'N' && orderLocal.DocStatus == 'O'"
                    class="mt-5">
                    <div class="grc-header mb-3" style="background: linear-gradient(135deg, #04abc5 0%, #04abc5 100%);">
                        <div class="grc-header-left">
                            <v-icon class="grc-header-icon" color="white" size="24">mdi-format-list-checks</v-icon>
                            <span class="grc-header-title">Actividades por Ítem de Servicio</span>
                        </div>
                        <div class="grc-header-right">
                            <span class="grc-selected-label">
                                {{activitiesList.filter(a => a.SoaCompleted == 1).length}}
                                / {{ activitiesList.length }} Finalizadas
                            </span>
                        </div>
                    </div>

                    <!-- Indicador de carga -->
                    <div v-if="loadingActivities" class="text-center py-6 white rounded-xl border">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                        <div class="text-caption grey--text mt-2">Cargando actividades...</div>
                    </div>

                    <!-- Sin actividades registradas -->
                    <div v-else-if="activitiesList.length === 0" class="text-center py-6 white rounded-xl border-dashed"
                        style="border: 2px dashed #e4e8f0; background-color: #fafbfe;">
                        <v-icon color="grey lighten-1" size="36">mdi-playlist-check</v-icon>
                        <div class="text-subtitle-2 grey--text text--darken-1 mt-1">
                            No hay actividades registradas en esta orden.
                        </div>
                        <div class="text-caption grey--text">
                            Se procederá con la validación aprobada de forma automática.
                        </div>
                    </div>

                    <!-- Listado agrupado por ítem -->
                    <div v-else v-for="item in itemsWithActivities" :key="item.OddID"
                        class="mb-2 pa-1 white rounded-xl shadow-sm" style="border: 1px solid #e4e8f0;">
                        <!-- Encabezado del Ítem -->
                        <div class="d-flex align-center justify-space-between mb-1">
                            <div class="d-flex align-center" style="min-width:0; flex: 1;">
                                <v-icon color="primary" class="mr-2">mdi-label-outline</v-icon>
                                <div style="min-width:0;">
                                    <div class="font-weight-bold text-subtitle-2 text-truncate primary--text"
                                        :title="item.OddDescription">
                                        {{ item.OddDescription || item.OddDescriptionNew }}
                                    </div>
                                    <div class="text-caption grey--text">
                                        Monto del Ítem: {{ item.TypeCurrencyName }}
                                        {{ item.OddAmount | numberDefault }}
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex align-center ml-4" style="gap: 12px; flex-shrink: 0;">
                                <v-chip small dark
                                    :color="item._completedCount === item._totalCount ? 'success' : 'warning'"
                                    class="font-weight-bold">
                                    {{ item._completedCount }} / {{ item._totalCount }} Completadas
                                </v-chip>
                            </div>
                        </div>

                        <!-- Tabla de actividades del Ítem -->
                        <v-data-table :headers="itemActivitiesHeaders" :items="item._activities" dense
                            hide-default-footer :items-per-page="-1" class="grc-table">
                            <!-- Columna de Estado -->
                            <template v-slot:item.SoaCompleted="{ item: act }">
                                <v-chip small dark outlined :color="act.SoaCompleted == 1 ? 'success' : 'orange'"
                                    class="font-weight-bold pa-2 rounded-lg" style="font-size: 0.725rem;">
                                    {{ act.SoaCompleted == 1 ? 'FINALIZADA' : 'PENDIENTE' }}
                                </v-chip>
                            </template>

                            <!-- Columna de Peso -->
                            <template v-slot:item.SoaWeightPercent="{ item: act }">
                                <span class="font-weight-bold">{{ act.SoaWeightPercent }}%</span>
                            </template>

                            <!-- Columna de Costo -->
                            <template v-slot:item.SoaCost="{ item: act }">
                                <span class="green--text text--darken-2 font-weight-bold">
                                    {{ item.TypeCurrencyName }} {{ act.SoaCost | numberDefault }}
                                </span>
                            </template>
                        </v-data-table>
                    </div>
                </div>

                <!-- RESUMEN DE FACTURAS -->
                <div class="grc-header" v-if="getLinesSummaryPurchaseInvoices.length > 0">
                    <div class="grc-header-left">
                        <v-icon class="grc-header-icon" color="white" size="28">mdi-receipt-text-check</v-icon>
                        <span class="grc-header-title">
                            Resumen de Facturas Proveedores
                        </span>
                    </div>
                    <div class="grc-header-right">
                        <span class="grc-selected-label">
                            {{ getLinesSummaryPurchaseInvoices.length }} item(s) facturado(s)
                        </span>
                    </div>
                </div>

                <v-data-table v-if="groupedPurchaseInvoices.length > 0" :headers="getGroupedHeadersSummaryInvoices"
                    :items="groupedPurchaseInvoices" item-key="uniqueId" dense hide-default-footer :items-per-page="-1"
                    class="grc-table mt-2">

                    <template v-slot:item.DocNum="{ item }">
                        <div class="d-flex flex-column align-center justify-center pa-1">
                            <span>{{ item.DocNum }}</span>
                            <v-chip x-small class="pa-1 px-2 font-weight-bold rounded-md">
                                {{ item.U_SYP_MDSD }}-{{ item.U_SYP_MDCD }}
                            </v-chip>
                        </div>
                    </template>

                    <template v-slot:item.DocDate="{ item }">
                        {{ $fun.formatDateView(item.DocDate) }}
                    </template>

                    <template v-slot:item.igv="{ item }">
                        <div class="qty-container text-center" v-if="item.items && item.items.length > 0">
                            {{ item.Currency }} {{ orderLocal.TypeCurrency == 2
                                ? item.items[0].VatSumFCInvoice :
                                item.items[0].VatSumInvoice }}
                        </div>
                    </template>

                    <template v-slot:item.total="{ item }">
                        <div class="qty-container text-center" v-if="item.items && item.items.length > 0">
                            {{ item.Currency }} {{ orderLocal.TypeCurrency == 2
                                ? item.items[0].DocTotalFCInvoice :
                                item.items[0].DocTotalInvoice }}
                        </div>
                    </template>

                    <template v-slot:item.constancia="{ item }">
                        <div class="text-center"
                            v-if="item.items && item.items.length > 0 && item.items[0].U_SYP_ANEXO6">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small color="primary" v-bind="attrs" v-on="on"
                                        @click.prevent="downloadFileSummary(item.items[0].U_SYP_ANEXO6)">
                                        <v-icon size="20">mdi-file-certificate-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Descargar Constancia CS</span>
                            </v-tooltip>
                        </div>
                        <div class="text-center grey--text text-caption" v-else>-</div>
                    </template>

                    <template v-slot:item.facturas="{ item }">
                        <div class="text-center d-flex align-center justify-center" style="gap: 4px;"
                            v-if="item.items && item.items.length > 0">
                            <!-- PDF -->
                            <v-tooltip bottom v-if="item.items[0].U_SYP_ANEXO7">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small color="error" v-bind="attrs" v-on="on"
                                        @click.prevent="downloadFileSummary(item.items[0].U_SYP_ANEXO7)">
                                        <v-icon size="20">mdi-file-pdf-box</v-icon>
                                    </v-btn>
                                </template>
                                <span>Descargar Factura PDF</span>
                            </v-tooltip>

                            <!-- XML -->
                            <v-tooltip bottom v-if="item.items[0].U_SYP_ANEXO8">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small color="success" v-bind="attrs" v-on="on"
                                        @click.prevent="downloadFileSummary(item.items[0].U_SYP_ANEXO8)">
                                        <v-icon size="20">mdi-xml</v-icon>
                                    </v-btn>
                                </template>
                                <span>Descargar Factura XML</span>
                            </v-tooltip>

                            <span class="grey--text text-caption"
                                v-if="!item.items[0].U_SYP_ANEXO7 && !item.items[0].U_SYP_ANEXO8">-</span>
                        </div>
                        <div class="text-center grey--text text-caption" v-else>-</div>
                    </template>

                    <template v-slot:item.actions="{ item }">
                        <div class="text-center">
                            <v-btn small depressed color="primary" class="rounded-lg" @click="openInvoiceDetails(item)">
                                <v-icon small left>mdi-eye</v-icon>
                                Ver
                            </v-btn>
                        </div>
                    </template>
                </v-data-table>

                <!-- Modal: Detalle de Factura Proveedor -->
                <v-dialog v-model="dialogInvoiceDetails" width="1000" v-if="dialogInvoiceDetails" scrollable>
                    <v-card class="rounded-xl overflow-hidden">
                        <!-- Header -->
                        <div class="d-flex align-center justify-space-between px-4 py-2"
                            style="background: linear-gradient(135deg, #04abc5 0%, #04abc5 100%); color: white; min-height: 52px;">
                            <div class="d-flex align-center">
                                <v-icon color="white" size="20" class="mr-2">mdi-receipt-text-check</v-icon>
                                <div>
                                    <div class="font-weight-bold" style="font-size: 14px;">
                                        Detalle de Factura
                                    </div>
                                    <div style="font-size: 11px; opacity: 0.9;" v-if="selectedInvoiceForDetails">
                                        Documento N° {{ selectedInvoiceForDetails.DocNum }} ({{
                                            selectedInvoiceForDetails.U_SYP_MDSD
                                        }}-{{ selectedInvoiceForDetails.U_SYP_MDCD }})
                                    </div>
                                </div>
                            </div>
                            <v-btn icon dark small @click="dialogInvoiceDetails = false">
                                <v-icon small>mdi-close</v-icon>
                            </v-btn>
                        </div>

                        <!-- Body / Table of items -->
                        <v-card-text class="px-4 py-3" style="max-height: 60vh; overflow-y: auto;">
                            <v-data-table v-if="selectedInvoiceForDetails" :headers="getDetailHeaders"
                                :items="selectedInvoiceForDetails.items" hide-default-footer :items-per-page="-1"
                                class="grc-table" dense>
                                <template v-slot:item.Description="{ item: subItem }">
                                    <div class="product-cell">
                                        <div class="product-desc" :title="subItem.Description">
                                            {{ subItem.Description }}
                                        </div>
                                        <span class="product-code" v-if="subItem.ItemCode">{{ subItem.ItemCode }}</span>
                                    </div>
                                </template>

                                <template v-slot:item.Price="{ item: subItem }">
                                    <div class="qty-container text-center">
                                        {{ subItem.Currency }} {{ subItem.Price }}
                                    </div>
                                </template>

                                <template v-slot:item.LineTotal="{ item: subItem }">
                                    <div class="qty-container text-center">
                                        {{ subItem.Currency }} {{ subItem.LineTotal }}
                                    </div>
                                </template>

                                <template v-slot:item.LineVat="{ item: subItem }">
                                    <div class="qty-container text-center">
                                        {{ subItem.Currency }} {{ subItem.LineVat }}
                                    </div>
                                </template>

                                <template v-slot:item.LineVatS="{ item: subItem }">
                                    <div class="qty-container text-center">
                                        {{ subItem.Currency }} {{ subItem.LineVatS }}
                                    </div>
                                </template>

                                <template v-slot:item.Quantity="{ item: subItem }">
                                    <div class="qty-container text-center" v-if="subItem.Quantity > 0">
                                        <span class="qty-value">
                                            {{ subItem.Quantity }} {{ subItem.UnitMsr }}
                                        </span>
                                    </div>
                                </template>

                                <template v-slot:item.PriceAfVAT="{ item: subItem }">
                                    <div class="qty-container text-center">
                                        {{ subItem.Currency }}
                                        <span class="qty-value" v-if="subItem.DocType == 'S'">
                                            {{ (subItem.VatPrcnt > 0) ? subItem.PriceAfVAT : subItem.PriceAfVAT }}
                                        </span>
                                        <span class="qty-value" v-else>
                                            {{ (subItem.PriceAfVAT * subItem.Quantity).toFixed(2) }}
                                        </span>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- FIN DE RESUMEN DE FACTURAS -->
            </v-col>

            <!-- formulario de generar Factura Proveedor  -->
            <!-- Banner: Orden cancelada en SAP (Factura Proveedor) -->
            <v-col cols="3" v-if="orderLocal.CANCELED == 'Y'">
                <div class="sap-canceled-banner">
                    <div class="sap-canceled-icon-wrap">
                        <v-icon size="48" color="#dc2626">mdi-file-cancel-outline</v-icon>
                    </div>
                    <div class="sap-canceled-title">Factura No Disponible</div>
                    <div class="sap-canceled-subtitle">
                        Esta orden de compra ha sido <strong>CANCELADA</strong> en SAP.
                        No es posible generar facturas de proveedor.
                    </div>
                </div>
            </v-col>

            <v-col cols="3" v-else-if="getLinesDeliveryNotesAvailablesToInvoices.length > 0">


                <div class="grc-col-form">
                    <div class="grc-form-title">
                        <v-icon small color="#04abc5" class="mr-1">mdi-form-select</v-icon>
                        Datos del Comprobante
                    </div>


                    <!-- Tipo Comprobante -->
                    <div class="grc-field-wrap">
                        <s-select label="TIPO DE COMPROBANTE" v-model="invoiceForm.U_SYP_MDTD" :items="paymentTypes"
                            outlined dense hide-details clearable></s-select>
                    </div>

                    <!-- Serie + Correlativo en la misma línea -->
                    <div class="grc-field-wrap grc-row-inline">
                        <div class="grc-field-half">
                            <label class="grc-input-label">SERIE</label>
                            <v-text-field v-model="invoiceForm.GrcSerie" outlined dense hide-details maxlength="4"
                                placeholder="A001" class="grc-field" />
                        </div>
                        <div class="grc-field-half">
                            <label class="grc-input-label">CORRELATIVO</label>
                            <v-text-field v-model="invoiceForm.GrcCorrelative" outlined dense hide-details maxlength="8"
                                placeholder="00000001" class="grc-field" />
                        </div>
                    </div>

                    <div v-if="orderLocal.TypeOrder == 1" class="grc-field-wrap">
                        <s-select-definition label="TIPO DE COMPRA" :def="1147" id="DedHelper"
                            v-model="invoiceForm.U_SYP_TCOMPRA" />
                    </div>

                    <div class="grc-field-wrap">
                        <s-select label="BIENES Y SERVICIOS ADQUIRIDO" v-model="invoiceForm.U_SYP_BIESRVADQ"
                            :items="goodServiceList" outlined dense hide-details clearable item-text="DedDescription"
                            item-value="DedValue"></s-select>
                    </div>

                    <!-- Single Upload Zone for Service Act (Servicios, TypeOrder == 3) -->
                    <div v-if="orderLocal.TypeOrder == 3" class="doc-upload-stack mb-1">
                        <input type="file" ref="fileInputServiceAct" id="service-act-upload-input"
                            accept=".pdf, image/*, .doc, .docx" hidden @change="handleServiceActFileEvent">
                        <label for="service-act-upload-input" class="doc-upload-card service-card"
                            :class="{ 'loaded': serviceActFile }">
                            <div class="doc-card-stripe service-stripe"></div>
                            <div class="doc-card-icon">
                                <v-icon size="30">
                                    {{ serviceActFile ? 'mdi-file-document-check' : 'mdi-file-signature' }}
                                </v-icon>
                            </div>
                            <div class="doc-card-body">
                                <span class="doc-card-label">ACTA DE CONFORMIDAD</span>
                                <span class="doc-card-name">
                                    {{
                                        serviceActFile ? serviceActFile.name.split(/[\\/]/).pop()
                                            : 'Click para seleccionar acta de servicio'
                                    }}
                                </span>
                            </div>
                            <div class="doc-card-right">
                                <span class="doc-card-badge service-badge" v-if="!serviceActFile">ACTA</span>
                                <div class="doc-card-success" v-else>
                                    <v-icon size="20" color="#22c55e">mdi-check-circle</v-icon>
                                    <v-btn icon x-small class="doc-delete-btn"
                                        @click.stop.prevent="clearServiceActFile">
                                        <v-icon size="16">mdi-close</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </label>
                    </div>



                    <!-- XML & PDF Upload Zone (Bienes/Artículos) -->
                    <!-- v-if="orderLocal.TypeOrder == 1" -->
                    <div class="doc-upload-stack mb-3">
                        <!-- XML Card -->
                        <input type="file" ref="fileInputXML_invoice" id="xml-upload-input-invoice" accept=".xml" hidden
                            @change="handleFileEvent($event)">
                        <label for="xml-upload-input-invoice" class="doc-upload-card xml-card"
                            :class="{ 'loaded': xmlFileInvoice }">
                            <div class="doc-card-stripe xml-stripe"></div>
                            <div class="doc-card-icon">
                                <v-icon size="30">
                                    {{ xmlFileInvoice ? 'mdi-file-xml-box' : 'mdi-code-brackets' }}
                                </v-icon>
                            </div>
                            <div class="doc-card-body">
                                <span class="doc-card-label">FACTURA XML</span>
                                <span class="doc-card-name">
                                    {{
                                        xmlFileInvoice
                                            ? xmlFileInvoice.name.split(/[\\/]/).pop() : 'Click para seleccionar archivo.xml'
                                    }}
                                </span>
                            </div>
                            <div class="doc-card-right">
                                <span class="doc-card-badge xml-badge" v-if="!xmlFileInvoice">XML</span>
                                <div class="doc-card-success" v-else>
                                    <v-icon size="20" color="#22c55e">mdi-check-circle</v-icon>
                                    <v-btn icon x-small class="doc-delete-btn" @click.stop.prevent="clearXMLFile()">
                                        <v-icon size="16">mdi-close</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                        </label>

                        <!-- PDF Card (visible only after XML is loaded) -->
                        <transition name="slide-down">
                            <div>
                                <input type="file" ref="fileInputPDF_invoice" id="pdf-upload-input-invoice"
                                    accept=".pdf" hidden @change="handlePDFFileEvent($event)">
                                <label for="pdf-upload-input-invoice" class="doc-upload-card pdf-card"
                                    :class="{ 'loaded': pdfFileInvoice }">
                                    <div class="doc-card-stripe pdf-stripe"></div>
                                    <div class="doc-card-icon">
                                        <v-icon size="30">
                                            {{ pdfFileInvoice ? 'mdi-file-pdf-box' : 'mdi-file-document-outline' }}
                                        </v-icon>
                                    </div>
                                    <div class="doc-card-body">
                                        <span class="doc-card-label">FACTURA PDF</span>
                                        <span class="doc-card-name">
                                            {{
                                                pdfFileInvoice ?
                                                    pdfFileInvoice.name.split(/[\\/]/).pop() :
                                                    'Click para seleccionar archivo.pdf'
                                            }}
                                        </span>
                                    </div>
                                    <div class="doc-card-right">
                                        <span class="doc-card-badge pdf-badge" v-if="!pdfFileInvoice">PDF</span>
                                        <div class="doc-card-success" v-else>
                                            <v-icon size="20" color="#22c55e">mdi-check-circle</v-icon>
                                            <v-btn icon x-small class="doc-delete-btn"
                                                @click.stop.prevent="clearPDFFile()">
                                                <v-icon size="16">mdi-close</v-icon>
                                            </v-btn>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </transition>
                    </div>

                    <!-- Botón -->
                    <v-btn block color="dark" dark class="grc-save-btn rounded-lg" elevation="0"
                        :disabled="orderLocal.TypeOrder == 1 && invoiceSelectedDeliveryNotes.length === 0"
                        @click="submitInvoice()">
                        <v-icon left small>mdi-check-circle-outline</v-icon>
                        REGISTRAR
                    </v-btn>
                </div>
            </v-col>
        </v-row>

        <AlertSunshine :dialog="processing" />
    </div>
</template>

<script>
import _sOrderPurchase from "@/services/Logistics/OrderPurchaseService";
import _sOrderPurchaseFile from "@/services/Logistics/LgsOrderPurchaseFile";
import _sRequirement from "@/services/Logistics/RequirementService";
import _sSaleOrder from "@/services/ExternalTrade/SaleOrderService.js";
import TrsBudgeService from '@/services/Treasury/TrsBudgeService';
import TrsBudgetDetailService from '@/services/Treasury/TrsBudgetDetailService';
import _OrderActivityService from "@/services/Logistics/ServiceOrderActivityService";
import _GenUploadFiles from "@/services/General/GenUploadFiles";
import _sGeneral from "@/services/HelperService.js";
import _sGenParam from "@/services/General/ParameterService";

export default {
    name: "PurchaseDeliveryNote",
    props: {
        orderLocal: { type: Object, default: {} },
    },
    data: () => {
        return {
            ValidateBudget: 0,
            dialogInvoiceDetails: false,
            selectedInvoiceForDetails: null,
            paymentTypes: [],
            processing: false,
            goodServiceList: [],
            activitiesList: [],
            loadingActivities: false,
            itemActivitiesHeaders: [
                { text: 'ACTIVIDAD', value: 'SoaDescription', sortable: false },
                { text: 'PESO', value: 'SoaWeightPercent', sortable: false, width: 100, align: 'center' },
                { text: 'COSTO', value: 'SoaCost', sortable: false, width: 120, align: 'right' },
                { text: 'ESTADO', value: 'SoaCompleted', sortable: false, width: 140, align: 'center' }
            ],
            invoiceForm: {
                U_SYP_MDTD: "00",
                GrcSerie: '',
                GrcCorrelative: '',
                U_SYP_BIESRVADQ: '*',
                U_SYP_TCOMPRA: '*',
            },
            invoiceSelectedServiceItems: [],
            invoiceSelectedDeliveryNotes: [],
            xmlFileInvoice: null,
            pdfFileInvoice: null,
            serviceActFile: null,
            conformityStatus: null,
            conformityComment: '',
            activeDisapprovalFileId: null,
            disapprovalComment: '',
            xmlDataInvoice: {
                invoiceNumber: '',
                total: 0, currency: '',
                documentTypeCode: '',
                issuerRUC: ''
            }
        }
    },
    computed: {
        getHeadersTableGenerateInvoice() {
            if (this.orderLocal.TypeOrder == 3) {
                return [
                    { text: 'LÍNEA', value: 'LineNumSap', sortable: false },
                    { text: 'DESCRIPCIÓN PRODUCTO', value: 'OddDescription', sortable: false },
                    { text: 'PRECIO', value: 'OddUnitPrice', sortable: false, width: 110, align: 'center' },
                    { text: 'IGV', value: 'OddTaxAmount', sortable: false, width: 110, align: 'center' },
                    { text: 'DSCTO', value: 'OddDiscountPercentage', sortable: false, width: 110, align: 'center' },
                    { text: 'TOTAL', value: 'OddAmount', sortable: false, width: 110, align: 'center' },
                    { text: 'PAGADO', value: 'TotalPayment', sortable: false, width: 110, align: 'center' },
                    // { text: 'ESTADO', value: 'LineStatusSap', sortable: false, width: 110, align: 'center' },
                ];
            }

            return [
                { text: 'N° DOC', value: 'DocNum', align: 'center', width: '110px', sortable: false },
                // { text: 'LÍNEA', value: 'BaseLine', sortable: false },
                { text: 'PRODUCTO', value: 'Description', align: 'start', sortable: false },
                { text: 'ALMACÉN', value: 'WhsCode', align: 'center', width: '90px', sortable: false },
                { text: 'CANT.', value: 'Quantity', align: 'center', width: '120px', sortable: false },
                { text: 'CANT. TOTAL', value: 'BaseQty', align: 'center', width: '120px', sortable: false },
            ];
        },
        getHeadaersSummaryDeliveryNotes() {
            // Price, --precio origen
            // LineTotal, --Precio convertido sino esta en PEN
            const columnPriceCurrency = this.orderLocal.TypeCurrency == 2 ? 'Price' : 'LineTotal';
            const columnVatCurrency = this.orderLocal.TypeCurrency == 2 ? 'LineVatS' : 'LineVat';
            if (this.orderLocal.TypeOrder == 1) {
                return [
                    { text: 'N° DOC', value: 'DocNum', align: 'center', width: '90px', sortable: false },
                    { text: 'FECHA', value: 'DocDate', align: 'center', width: '90px', sortable: false },
                    { text: 'PRODUCTO', value: 'Description', align: 'start', sortable: false },
                    { text: 'ALMACÉN', value: 'WhsCode', align: 'center', width: '90px', sortable: false },
                    // { text: 'PRECIO.', value: 'Price', align: 'center', width: '90px', sortable: false },
                    { text: 'CANT.', value: 'Quantity', align: 'center', width: '90px', sortable: false },
                    // { text: 'TOTAL', value: 'PriceAfVAT', align: 'center', width: '110px', sortable: false },
                    // { text: 'FACTURA', value: 'U_SYP_MDSD', align: 'center', width: '110px', sortable: false },
                ];
            } else {
                return [
                    { text: 'N° DOC', value: 'DocNum', align: 'center', sortable: false },
                    { text: 'FECHA', value: 'DocDate', align: 'center', width: '90px', sortable: false },
                    { text: 'PRODUCTO', value: 'Description', align: 'start', sortable: false },
                    { text: 'PRECIO.', value: columnPriceCurrency, align: 'center', width: '120px', sortable: false },
                    { text: 'IGV.', value: columnVatCurrency, align: 'center', width: '120px', sortable: false },
                    // { text: 'CANT.', value: 'Quantity', align: 'center', width: '120px', sortable: false },
                    { text: 'TOTAL', value: 'PriceAfVAT', align: 'center', width: '120px', sortable: false },
                    // { text: 'FACTURA', value: 'U_SYP_MDSD', align: 'center', width: '110px', sortable: false },
                ];
            }
        },
        getLinesDeliveryNotesAvailablesToInvoices() {
            if (this.orderLocal.TypeOrder == 3) {
                return this.getServicesAvailablesToInvoices;
            }

            const list = (this.orderLocal.PurchaseDeliveryNotesDetail && this.orderLocal.PurchaseDeliveryNotesDetail.length > 0) ? this.orderLocal.PurchaseDeliveryNotesDetail : [];
            return list.filter(x => x.LineStatus == 'O' && x.CANCELED == 'N').map((item, index) => ({ ...item, uniqueId: 'dn-' + index }));
        },
        getServicesAvailablesToInvoices() {
            const list = (this.orderLocal.DetailPedidoSAP && this.orderLocal.DetailPedidoSAP.length > 0) ? this.orderLocal.DetailPedidoSAP : [];
            return list.filter(item => item.LineStatusSap == 'O')
                .map((item, index) => ({ ...item, OddAmountInvoice: (item.OddAmount - item.TotalPayment).toFixed(3), uniqueId: 'dl-' + index }));
        },
        getLinesSummaryPurchaseInvoices() {
            return (this.orderLocal.PurchaseInvoicesDetail && this.orderLocal.PurchaseInvoicesDetail.length > 0) ? this.orderLocal.PurchaseInvoicesDetail : [];
        },
        itemsWithActivities() {
            if (this.orderLocal.TypeOrder != 3) return [];
            return this.getServicesAvailablesToInvoices.map(item => {
                const acts = this.activitiesList.filter(a => a.OddID === item.OddID);
                return {
                    ...item,
                    _activities: acts,
                    _completedCount: acts.filter(a => a.SoaCompleted == 1).length,
                    _totalCount: acts.length
                };
            }).filter(item => item._activities.length > 0);
        },
        groupedPurchaseInvoices() {
            const rawInvoices = (this.orderLocal.PurchaseInvoicesDetail && this.orderLocal.PurchaseInvoicesDetail.length > 0) ? this.orderLocal.PurchaseInvoicesDetail : [];
            const grouped = {};
            rawInvoices.forEach(item => {
                const key = `${item.DocNum}_${item.DocDate}`;
                if (!grouped[key]) {
                    grouped[key] = {
                        DocNum: item.DocNum,
                        DocDate: item.DocDate,
                        U_SYP_MDSD: item.U_SYP_MDSD,
                        U_SYP_MDCD: item.U_SYP_MDCD,
                        Currency: item.Currency,
                        items: [],
                        uniqueId: key
                    };
                }
                grouped[key].items.push(item);
            });
            return Object.values(grouped);
        },
        getGroupedHeadersSummaryInvoices() {
            if (this.orderLocal.TypeOrder == 3) {
                return [
                    { text: 'N° DOC', value: 'DocNum', align: 'center', width: '110px', sortable: false },
                    { text: 'FECHA', value: 'DocDate', align: 'center', width: '90px', sortable: false },
                    { text: 'IGV', value: 'igv', align: 'center', width: '100px', sortable: false },
                    { text: 'TOTAL', value: 'total', align: 'center', width: '100px', sortable: false },
                    { text: 'CONSTANCIA', value: 'constancia', align: 'center', width: '100px', sortable: false },
                    { text: 'FACTURAS', value: 'facturas', align: 'center', width: '100px', sortable: false },
                    { text: 'DETALLE', value: 'actions', align: 'center', width: '90px', sortable: false }
                ];
            } else {
                return [
                    { text: 'N° DOC', value: 'DocNum', align: 'center', width: '130px', sortable: false },
                    { text: 'FECHA', value: 'DocDate', align: 'center', width: '120px', sortable: false },
                    { text: 'FACTURAS', value: 'facturas', align: 'center', width: '120px', sortable: false },
                    { text: 'DETALLE', value: 'actions', align: 'center', width: '90px', sortable: false }
                ];
            }
        },
        getDetailHeaders() {
            return this.getHeadaersSummaryDeliveryNotes.filter(h => h.value !== 'DocNum' && h.value !== 'DocDate');
        },

    },
    methods: {
        openInvoiceDetails(item) {
            this.selectedInvoiceForDetails = item;
            this.dialogInvoiceDetails = true;
        },
        submitInvoice() {

            // console.log(JSON.parse(JSON.stringify({ invoiceSelectedDeliveryNotes: this.invoiceSelectedDeliveryNotes })));
            // console.log(JSON.parse(JSON.stringify({ invoiceSelectedServiceItems: this.invoiceSelectedServiceItems })));

            // Validación: Si el documento está cerrado (DocStatus == 'C'), no permitir continuar
            if (this.orderLocal && this.orderLocal.CANCELED == 'Y') {
                this.$fun.alert('NO SE PUEDE GENERAR LA FACTURA PORQUE LA ORDEN SE ENCUENTRA CANCELADA.', 'warning');
                return;
            }

            // 1. Validaciones de items seleccionados
            if (this.orderLocal.TypeOrder == 1) {
                if (!this.invoiceSelectedDeliveryNotes || this.invoiceSelectedDeliveryNotes.length == 0) {
                    this.$fun.alert('DEBE SELECCIONAR AL MENOS UN ÍTEM DE LA ENTRADA DE MERCANCÍA PARA GENERAR LA FACTURA.', 'warning');
                    return;
                }
            } else {
                if (!this.invoiceSelectedServiceItems || this.invoiceSelectedServiceItems.length == 0) {
                    this.$fun.alert('NO HAY ÍTEMS DE SERVICIOS PARA GENERAR FACTURA.', 'warning');
                    return;
                }
            }

            // Validation for TypeOrder = 3: All activities must be completed/finalized (only if activities exist).
            if (this.orderLocal.TypeOrder == 3) {
                if (this.loadingActivities) {
                    this.$fun.alert('CARGANDO ACTIVIDADES. POR FAVOR ESPERE...', 'info');
                    return;
                }
                // const pendingActivities = this.activitiesList.filter(a => a.SoaCompleted != 1);
                // if (this.activitiesList.length > 0 && pendingActivities.length > 0) {
                //     this.$fun.alert('NO SE PUEDE GENERAR LA FACTURA PORQUE TIENE ACTIVIDADES PENDIENTES. POR FAVOR FINALICE TODAS LAS ACTIVIDADES.', 'warning');
                //     return;
                // }

                // Validación de monto de ítem contra sumatoria de actividades finalizadas
                for (const item of this.invoiceSelectedServiceItems) {
                    // console.log((item.OddAmount - item.TotalPayment).toFixed(3));
                    if (parseFloat(item.OddAmountInvoice) <= 0) {
                        this.$fun.alert(`EL MONTO A FACTURAR DEL ÍTEM [${item.LineNumSap}] NO PUEDE SER MENOR O IGUAL A CERO.`, 'warning');
                        return;
                    }

                    // console.log(JSON.parse(JSON.stringify(item)));
                    const pendingTotal = parseFloat((item.OddAmount - item.TotalPayment).toFixed(3));
                    if (parseFloat(item.OddAmountInvoice) > pendingTotal) {
                        this.$fun.alert(`EL MONTO A FACTURAR DEL ÍTEM [${item.LineNumSap}] NO PUEDE SUPERAR EL MONTO TOTAL PENDIENTE DEL ÍTEM.`, 'warning');
                        return;
                    }

                    const itemActs = this.activitiesList.filter(a => a.OddID === item.OddID);
                    if (itemActs.length > 0) {
                        const completedSum = parseFloat(itemActs
                            .filter(a => a.SoaCompleted == 1)
                            .reduce((sum, a) => sum + (parseFloat(a.SoaCost) || 0), 0)
                            .toFixed(3));

                        const amountInvoice = parseFloat(parseFloat(item.OddAmountInvoice || 0).toFixed(3));
                        const maxAllowed = parseFloat((completedSum - item.TotalPayment).toFixed(3));
                        if (amountInvoice > maxAllowed) {
                            this.$fun.alert(`EL MONTO A FACTURAR DEL ÍTEM [${item.LineNumSap}] (S/ ${amountInvoice.toFixed(3)}) NO PUEDE SUPERAR EL LÍMITE DISPONIBLE DE SUS ACTIVIDADES FINALIZADAS MENOS LO YA PAGADO (S/ ${maxAllowed.toFixed(3)}).`, 'warning');
                            return;
                        }
                    }
                }
            }

            // 3. Tipo de Comprobante requerido
            if (!this.invoiceForm.U_SYP_MDTD || this.invoiceForm.U_SYP_MDTD == "00") {
                this.$fun.alert('EL CAMPO TIPO DE COMPROBANTE ES REQUERIDO.', 'warning');
                return
            }

            // TIPO DE COMPRA requerido solo cuando TypeOrder == 1
            if (this.orderLocal.TypeOrder == 1) {
                if (!this.invoiceForm.U_SYP_TCOMPRA || this.invoiceForm.U_SYP_TCOMPRA == "*") {
                    this.$fun.alert('EL CAMPO TIPO DE COMPRA ES REQUERIDO.', 'warning');
                    return;
                }
            }

            // 2. BIENES Y SERVICIOS ADQUIRIDO requerido para ambos casos (Me valida service Layer)
            if (!this.invoiceForm.U_SYP_BIESRVADQ || this.invoiceForm.U_SYP_BIESRVADQ == "*") {
                this.$fun.alert('EL CAMPO BIENES Y SERVICIOS ADQUIRIDO ES REQUERIDO.', 'warning');
                return;
            }

            // 4 & 5. Serie y Correlativo
            const serie = (this.invoiceForm.GrcSerie || '').trim();
            const correlativo = (this.invoiceForm.GrcCorrelative || '').trim();
            if (!this.validateDocumentNumbers(serie, correlativo)) return;

            let today = new Date();
            let dd = String(today.getDate()).padStart(2, '0');
            let mm = String(today.getMonth() + 1).padStart(2, '0');
            let yyyy = today.getFullYear();
            today = yyyy + '-' + mm + '-' + dd;

            // Construir payload
            const payload = {
                CardCode: this.orderLocal?.SupCode ?? "",
                DocDate: today,
                DocDueDate: today,
                Comments: this.orderLocal?.OrdObservation,
                U_SYP_MDTD: this.invoiceForm.U_SYP_MDTD,
                U_SYP_MDSD: serie,
                U_SYP_MDCD: correlativo,
                U_SYP_BIESRVADQ: this.invoiceForm.U_SYP_BIESRVADQ.toString(),
            };

            // U_SYP_TCOMPRA se envía solo cuando TypeOrder == 1
            if (this.orderLocal.TypeOrder == 1) {
                payload.U_SYP_TCOMPRA = this.invoiceForm.U_SYP_TCOMPRA;
            }

            // Si utiliza el flujo (Pedido -> Entrada de Mercancías -> Factura), el BaseType de tu factura ya no debe ser el pedido (22), 
            // sino que debe apuntar a la Entrada de Mercancías (20). 
            // Si van directo de Pedido a Factura, usas 22.

            if (this.orderLocal.TypeOrder == 1) {
                payload.DocType = "I"; // Items
                payload.DocumentLines = this.invoiceSelectedDeliveryNotes.map((item) => ({
                    BaseType: 20, // Entrada de mercancía (Goods Receipt)
                    BaseEntry: parseInt(item.DocEntry),
                    BaseLine: parseInt(item.LineNum),
                    Quantity: parseFloat(item.Quantity),
                }));
            } else {
                payload.DocType = "S"; // Service
                payload.DocumentLines = this.invoiceSelectedServiceItems.map((item) => ({
                    BaseType: 22,
                    BaseEntry: parseInt(this.orderLocal.DocEntry), //78603
                    BaseLine: parseInt(item?.LineNumSap ?? (item.Line - 1)),
                    AccountCode: item.OddAccount || "", //"6343101"
                    DiscountPercent: parseFloat(item.OddDiscountPercentage || 0.0),
                    UnitPrice: this.getAmountSinIGV(item.OddAmountInvoice, item.OddTaxPercentage).toFixed(3), // (parseFloat(item.OddUnitPrice) - parseFloat(item.OddDiscount)).toFixed(2), //5742.4
                    PriceAfterVAT: null,
                    TaxOnly: "tNO"
                }));
            }

            console.log('Payload Factura:', JSON.parse(JSON.stringify(payload, null, 2)));

            if (payload.CardCode == "") {
                this.$fun.alert('NO SE ENCONTRO EL PROVEEDOR EN LA ORDEN', 'warning');
                return;
            }

            if (!payload.DocumentLines || payload.DocumentLines.length === 0) {
                this.$fun.alert('NO HAY LÍNEAS PARA GENERAR FACTURA.', 'warning');
                return;
            }

            if (!parseInt(payload.DocumentLines[0].BaseEntry ?? 0) > 0) {
                this.$fun.alert('DocEntry NO ENCONTRADO EN LAS LÍNEAS DE LA ORDEN/ENTRADA', 'warning');
                return;
            }

            if (this.orderLocal.TypeOrder != 1 && (payload.DocumentLines[0].AccountCode ?? "") == "") {
                this.$fun.alert('CUENTA NO ENCONTRADA EN LA ORDEN', 'warning');
                return;
            }

            // if (this.orderLocal.TypeOrder == 1) {
            //     if (!this.xmlFileInvoice) {
            //         this.$fun.alert('EL COMPROBANTE XML ES REQUERIDO PARA BIENES.', 'warning');
            //         return;
            //     }
            // } else if (this.orderLocal.TypeOrder == 3) {
            //     if (!this.serviceActFile) {
            //         this.$fun.alert('EL ACTA DE SERVICIO ES REQUERIDA.', 'warning');
            //         return;
            //     }
            // }

            this.$fun.alert("Seguro de Generar Factura Proveedor SAP?", "question").then(async (r) => {
                if (r.value) {
                    this.processing = true;
                    let pathInvoiceNumberXml = null;
                    let pathInvoiceNumberPdf = null;
                    let pathActConfirm = null;

                    const docType = this.invoiceForm.U_SYP_MDTD || '00';
                    const ruc = this.xmlDataInvoice?.issuerRUC || payload.CardCode.replace(/^[A-Z]+/i, '') || 'RUC';
                    const fileNum = this.xmlDataInvoice?.invoiceNumber || `${serie}-${correlativo}`;
                    const fileName = `${ruc}-${docType}-${fileNum}`;

                    if (this.xmlFileInvoice) {
                        if (this.xmlFileInvoice instanceof File) {
                            const uploadedXML = await this.loadFileOnServer(this.xmlFileInvoice, fileName);
                            if (uploadedXML && uploadedXML.success) {
                                pathInvoiceNumberXml = uploadedXML.path;
                            } else {
                                this.$fun.alert("Error al subir XML: " + (uploadedXML?.message || 'Error'), "error");
                                this.processing = false;
                                return;
                            }
                        } else {
                            pathInvoiceNumberXml = this.xmlFileInvoice.name;
                        }
                    }

                    if (this.pdfFileInvoice) {
                        if (this.pdfFileInvoice instanceof File) {
                            const uploadedPDF = await this.loadFileOnServer(this.pdfFileInvoice, fileName);
                            if (uploadedPDF && uploadedPDF.success) {
                                pathInvoiceNumberPdf = uploadedPDF.path;
                            } else {
                                this.$fun.alert("Error al subir PDF: " + (uploadedPDF?.message || 'Error'), "error");
                                this.processing = false;
                                return;
                            }
                        } else {
                            pathInvoiceNumberPdf = this.pdfFileInvoice.name;
                        }
                    }

                    if (this.orderLocal.TypeOrder != 1) {
                        if (this.serviceActFile) {
                            if (this.serviceActFile instanceof File) {
                                const docType = this.invoiceForm.U_SYP_MDTD || '00';
                                const ruc = payload.CardCode.replace(/^[A-Z]+/i, '') || 'RUC';
                                const fileNum = `${serie}-${correlativo}`;
                                const originalName = this.serviceActFile.name;
                                const extension = originalName.substring(originalName.lastIndexOf('.'));
                                const fileName = `${ruc}-${docType}-${fileNum}${extension}`;

                                const uploadedAct = await this.loadFileOnServer(this.serviceActFile, fileName);
                                if (uploadedAct && uploadedAct.success) {
                                    pathActConfirm = uploadedAct.path;
                                } else {
                                    this.$fun.alert("Error al subir el Acta de Servicio: " + (uploadedAct?.message || 'Error'), "error");
                                    this.processing = false;
                                    return;
                                }
                            } else {
                                pathActConfirm = this.serviceActFile.name;
                            }
                        }
                    }

                    if (pathInvoiceNumberPdf) {
                        payload.U_SYP_ANEXO7 = pathInvoiceNumberPdf;
                    }
                    if (pathInvoiceNumberXml) {
                        payload.U_SYP_ANEXO8 = pathInvoiceNumberXml;
                    }
                    if (this.orderLocal.TypeOrder != 1) {
                        payload.U_SYP_ANEXO6 = pathActConfirm;
                    }

                    // Add CDR file (AttachmentIndex 9) if approved (FilStatus 2)
                    if (this.orderLocal && this.orderLocal.PurchaseFiles) {
                        const cdrFile = this.orderLocal.PurchaseFiles.find(file => file.AttachmentIndex == 9 && file.FilStatus == 2);
                        if (cdrFile) {
                            payload.U_SYP_ANEXO9 = this.orderLocal.U_SYP_ANEXO9;
                        }
                    }

                    const capturarRespuestaOk = async (invoiceResult) => {
                        console.log(JSON.parse(JSON.stringify({ invoiceResult })));
                        if (this.orderLocal.TypeOrder == 3) {
                            await this.updateStatusOrderAfterDispatch();
                        }

                        if (this.ValidateBudget == 1) {
                            await this.saveBudget();
                        }

                        this.invoiceSelectedDeliveryNotes = [];
                        this.invoiceSelectedServiceItems = [];
                        this.invoiceForm = {
                            U_SYP_MDTD: "00",
                            GrcSerie: '',
                            GrcCorrelative: '',
                            U_SYP_BIESRVADQ: '*',
                            U_SYP_TCOMPRA: '*',
                        };
                        this.xmlFileInvoice = null;
                        this.pdfFileInvoice = null;
                        this.serviceActFile = null;
                        this.xmlDataInvoice = {
                            invoiceNumber: '',
                            total: 0,
                            currency: '',
                            documentTypeCode: '',
                            issuerRUC: ''
                        }
                        this.$emit("SavedInvoice");
                        this.$fun.alert("Factura Proveedor registrada correctamente", "success");
                        this.processing = false;
                        // this.$emit("onClose");
                    }

                    const capturarError = (error) => {
                        this.invoiceSelectedDeliveryNotes = [];
                        this.invoiceSelectedServiceItems = [];
                        this.processing = false;
                        let errorMsg = error?.response?.data?.Message || "Error desconocido";

                        try {
                            const parsed = JSON.parse(errorMsg);
                            if (parsed.error) {
                                try {
                                    const sapError = JSON.parse(parsed.error);
                                    errorMsg = sapError?.error?.message?.value || parsed.userFriendlyMessage || errorMsg;
                                } catch (e) {
                                    errorMsg = parsed.userFriendlyMessage || errorMsg;
                                }
                                if (errorMsg.includes("Update the exchange rate")) {
                                    errorMsg = "Actualizar el tipo de cambio";
                                }
                            } else if (parsed.userFriendlyMessage) {
                                errorMsg = parsed.userFriendlyMessage;
                            }
                        } catch (e) {
                        }

                        this.message = errorMsg;
                        this.$fun.alert(errorMsg, 'error');
                    }

                    _sOrderPurchase.loadPurchaseInvoiceSapDemo(payload, this.$fun.getUserSAPInfo().UsrID, this.$fun.getUserID()).then(capturarRespuestaOk, capturarError);
                }
            });
        },
        async updateStatusOrderAfterDispatch() {
            if ([5, 10].includes(this.orderLocal.OrdStatus)) {
                try {
                    const updatedSAP = await _sOrderPurchase.setStatusAfterDispatch(this.orderLocal, this.$fun.getUserID());
                    console.log(JSON.parse(JSON.stringify({ updatedSAP })));
                } catch (error) {
                    console.log("Error on updateStatusOrderAfterDispatch:", error);
                }
            }
        },
        validateDocumentNumbers(serie, correlativo) {
            serie = (serie || '').trim();
            if (this.orderLocal.TypeOrder == 1 || this.orderLocal.TypeOrder == 3 && serie != '') {
                if (!serie) {
                    this.$fun.alert('EL CAMPO SERIE ES REQUERIDO.', 'warning');
                    return false;
                } else if (serie.length !== 4) {
                    this.$fun.alert('LA SERIE DEBE TENER EXACTAMENTE 4 CARACTERES.', 'warning');
                    return false;
                } else if (!/^[A-Z0-9]{4}$/.test(serie)) {
                    this.$fun.alert('LA SERIE SOLO ADMITE LETRAS MAYÚSCULAS (A-Z) Y NÚMEROS (0-9), SIN ESPACIOS NI CARACTERES ESPECIALES.', 'warning');
                    return false;
                }
            }

            correlativo = (correlativo || '').trim();
            if (this.orderLocal.TypeOrder == 1 || this.orderLocal.TypeOrder == 3 && correlativo != '') {
                if (!correlativo) {
                    this.$fun.alert('EL CAMPO CORRELATIVO ES REQUERIDO.', 'warning');
                    return false;
                } else if (!/^[0-9]{1,8}$/.test(correlativo)) {
                    this.$fun.alert('EL CORRELATIVO SOLO ADMITE DÍGITOS NUMÉRICOS (0-9) Y UN MÁXIMO DE 8 DÍGITOS.', 'warning');
                    return false;
                }
                return true;
            }
            return true;
        },
        async loadFileOnServer(model, fileName, paramRoute = "RutaAnexosSAP", overwrite = true) {
            try {
                const response = await _GenUploadFiles.upload(model, fileName.toUpperCase(), paramRoute, overwrite);
                console.log({ response })
                if (response.status == 200) {
                    return {
                        success: true,
                        message: response.data.message,
                        path: response.data.path,
                        fileName: response.data.fileName,
                    }
                } else {
                    return {
                        success: false,
                        message: 'Error al subir archivo',
                    }
                }
            } catch (error) {
                console.log("Error on loadFileOnServer: ", error);
                let errMsg = error.message;
                if (error?.response?.data?.Message) {
                    errMsg = error.response.data.Message;
                }
                return {
                    success: false,
                    message: errMsg || 'Error al subir archivo',
                }
            }
        },
        getAmountSinIGV(amount, percentIGV) {
            return parseFloat((amount / (1 + (percentIGV / 100))));
        },
        getAmountWithIGV(amount, percentIGV) {
            return parseFloat((amount * (1 + (percentIGV / 100))));
        },
        fetchOrderActivities() {
            if (!this.orderLocal || !this.orderLocal.OrdID) return;
            if (this.orderLocal.TypeOrder != 3) return;

            this.loadingActivities = true;
            this.activitiesList = [];
            let items = this.orderLocal.Detail ? this.orderLocal.Detail : [];

            const promises = items.map(item => {
                if (!item.OddID) return Promise.resolve([]);
                const params = {
                    filter: { OddID: item.OddID },
                    draw: 1,
                    start: 0,
                    length: 500
                };
                return _OrderActivityService.pagination(params, this.$fun.getUserID()).then(r => {
                    const data = r.data?.data || [];
                    return data.map(act => ({
                        ...act,
                        OddDescription: item.OddDescription || item.OddDescriptionNew
                    }));
                }).catch(() => []);
            });

            Promise.all(promises).then(results => {
                this.activitiesList = results.flat();
            }).finally(() => {
                this.loadingActivities = false;
            });
        },
        itemServiceInvoiceIsSelected(item) {
            return this.invoiceSelectedServiceItems.some(s => s.Line === item.Line);
        },
        onServiceAmountInvoiceInput(item) {
            if (item.OddAmountInvoice < 0) item.OddAmountInvoice = 0;
        },
        onServiceAmountInvoiceBlur(item) {
            if (!item.OddAmountInvoice || item.OddAmountInvoice < 0) item.OddAmountInvoice = 0;
            if (item.OddAmountInvoice > parseFloat(item.OddAmount || 0)) {
                this.$fun.alert(`El monto facturado supera el monto del item en la OC.`, 'warning');
            }
        },
        async saveBudget() {
            const usrID = this.$fun.getUserID();
            const year = this.orderLocal.OrdDate.split('-')[0];
            const selectedItems = (this.orderLocal.TypeOrder == 1 ? this.invoiceSelectedDeliveryNotes : this.invoiceSelectedServiceItems);

            for (let item of selectedItems) {
                const params = {
                    PrjCode: item[this.getValueByKeyToBudget('Project', 'PrjCode')], //item.PrjCode,
                    AreID: this.orderLocal.AreID,
                    BslID: item[this.getValueByKeyToBudget('OcrCode2', 'BslID')], // item.BslID,
                    BgtYear: year,
                }

                const resultadoTrs = await TrsBudgeService.list(params, usrID);
                console.log(JSON.parse(JSON.stringify({ params, resultadoTrs })))

                if (resultadoTrs.status == 200 && resultadoTrs.data.length > 0) {
                    const budget = resultadoTrs.data[0];
                    let amount = 0;
                    if (this.orderLocal.TypeOrder == 1) {
                        amount = (this.getAmountWithIGV(item.Price, item.VatPrcnt) * item.Quantity).toFixed(3);
                    } else {
                        amount = item.OddAmount;
                    }
                    const modelDetail = {
                        BgdID: 0,
                        BgtID: budget.BgtID,
                        BgdDescription: item[this.getValueByKeyToBudget('Description', 'OddDescription')], //item.OddDescription,
                        BgdAmount: amount, // this.getAmountWithIGV(item.OddAmount, item.OddTaxPercentage) * item.GrcQuantity,
                        BgdOperationType: 1,
                        BgdDate: new Date(), //item.OddDate,
                        BdgReqID: item[this.getValueByKeyToBudget('U_SUN_REQID', 'ReqID')], //item.ReqID, //ID REQUERIMIENTO 
                        BdgReference: 2, //REQUERIMIENTO
                        BdgReferenceID: item.OddID, //ID ORDEN DETALLE
                        BdgState: 2, //EJECUTADO
                        SecStatus: 1,
                        UsrCreateID: usrID,
                    }

                    console.log(JSON.parse(JSON.stringify({ modelDetail })));
                    TrsBudgetDetailService.save(modelDetail, usrID).then((r) => {
                        console.log(JSON.parse(JSON.stringify({ r })))
                    });
                }
            }
        },
        getValueByKeyToBudget(keyObjectCompra, keyObjectService) {
            return this.orderLocal.TypeOrder == 1 ? keyObjectCompra : keyObjectService;
        },
        onSelectAllServiceToInvoice({ items, value }) {
            if (value) {
                items.filter(i => i.LineStatusSap == 'O').forEach(item => {
                    if (this.orderLocal.TypeOrder == 3) {
                        const itemActs = this.activitiesList.filter(a => a.OddID === item.OddID);
                        if (itemActs.length > 0) {
                            const completedSum = parseFloat(itemActs
                                .filter(a => a.SoaCompleted == 1)
                                .reduce((sum, a) => sum + (parseFloat(a.SoaCost) || 0), 0)
                                .toFixed(3));
                            const maxFromActivities = completedSum - item.TotalPayment;
                            const maxTotalPending = item.OddAmount - item.TotalPayment;
                            let recommendedAmount = Math.min(maxFromActivities, maxTotalPending);
                            if (recommendedAmount < 0) {
                                recommendedAmount = 0;
                            }
                            item.OddAmountInvoice = parseFloat(recommendedAmount.toFixed(3));
                            return;
                        } else {
                            const maxTotalPending = item.OddAmount - item.TotalPayment;
                            let recommendedAmount = maxTotalPending;
                            if (recommendedAmount < 0) {
                                recommendedAmount = 0;
                            }
                            item.OddAmountInvoice = parseFloat(recommendedAmount.toFixed(3));
                            return;
                        }
                    }
                    if (item.OddAmountInvoice === 0) {
                        item.OddAmountInvoice = parseFloat(item.OddUnitPrice) || 0;
                    }
                });
            }
        },
        onServiceItemSelected({ item, value }) {
            if (this.orderLocal.TypeOrder == 3 && value) {
                const itemActs = this.activitiesList.filter(a => a.OddID === item.OddID);
                if (itemActs.length > 0) {
                    const completedSum = parseFloat(itemActs
                        .filter(a => a.SoaCompleted == 1)
                        .reduce((sum, a) => sum + (parseFloat(a.SoaCost) || 0), 0)
                        .toFixed(3));
                    const maxFromActivities = completedSum - item.TotalPayment;
                    const maxTotalPending = item.OddAmount - item.TotalPayment;
                    let recommendedAmount = Math.min(maxFromActivities, maxTotalPending);
                    if (recommendedAmount < 0) {
                        recommendedAmount = 0;
                    }
                    item.OddAmountInvoice = parseFloat(recommendedAmount.toFixed(3));
                } else {
                    const maxTotalPending = item.OddAmount - item.TotalPayment;
                    let recommendedAmount = maxTotalPending;
                    if (recommendedAmount < 0) {
                        recommendedAmount = 0;
                    }
                    item.OddAmountInvoice = parseFloat(recommendedAmount.toFixed(3));
                }
            }
        },

        handleFileEvent(e) {
            const file = e.target.files[0];
            if (!file) {
                this.xmlDataInvoice = {
                    invoiceNumber: '',
                    total: 0, currency: '',
                    documentTypeCode: '',
                    issuerRUC: ''
                };
                return;
            }

            this.xmlFileInvoice = file;
            this.pdfFileInvoice = null;
            if (this.$refs.fileInputPDF_invoice) this.$refs.fileInputPDF_invoice.value = "";

            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(e.target.result, "text/xml");
                    const root = xmlDoc.documentElement;

                    // Helper: texto limpio de un nodo
                    const txt = (node) => (node?.textContent || '').trim();

                    // Helper: busca por localName probando 3 formas para cubrir cualquier namespace
                    const byLocal = (localName) => {
                        return root.getElementsByTagNameNS("*", localName)[0]
                            || root.getElementsByTagName("cbc:" + localName)[0]
                            || root.getElementsByTagName(localName)[0]
                            || null;
                    };

                    // ── 1. Tipo de documento ───────────────────────────────────────────
                    let documentTypeCode = '';

                    const despatchTypeNode = byLocal('DespatchAdviceTypeCode'); // GRE=09 | GRT=31
                    const invoiceTypeNode = byLocal('InvoiceTypeCode');        // Factura/Boleta
                    const creditNoteNode = byLocal('DiscrepancyResponse');    // Nota Crédito
                    const debitNoteNode = byLocal('DebitReasonCode');        // Nota Débito

                    if (despatchTypeNode) {
                        // Usamos el valor real del tag (puede ser "09" para GRE o "31" para GRT)
                        // Solo caemos a "09" si el tag existe pero su contenido es vacío
                        const val = txt(despatchTypeNode);
                        documentTypeCode = val !== '' ? val : '09';
                    } else if (invoiceTypeNode) {
                        const val = txt(invoiceTypeNode);
                        documentTypeCode = val !== '' ? val : '01';
                    } else if (creditNoteNode) {
                        documentTypeCode = '07';
                    } else if (debitNoteNode) {
                        documentTypeCode = '08';
                    } else {
                        // Fallback por nombre del elemento raíz
                        const rootName = root.localName || root.nodeName.split(':').pop();
                        if (rootName.includes('DespatchAdvice')) documentTypeCode = '09';
                        else if (rootName.includes('CreditNote')) documentTypeCode = '07';
                        else if (rootName.includes('DebitNote')) documentTypeCode = '08';
                        else documentTypeCode = '01';
                    }
                    // ── 2. Número del comprobante ─────────────────────────────
                    // Primer hijo elemento del root con localName "ID"
                    let invoiceNumber = '';
                    const rootChildren = root.childNodes;
                    for (let i = 0; i < rootChildren.length; i++) {
                        const child = rootChildren[i];
                        const lname = child.localName || child.nodeName.split(':').pop();
                        if (child.nodeType === 1 && lname === 'ID') {
                            invoiceNumber = (child.textContent || '').trim();
                            break;
                        }
                    }

                    // ── 3. Guardar y autocompletar ─────────────────────────────
                    const xmlData = { invoiceNumber, documentTypeCode, issuerRUC: '', total: 0, currency: 'PEN' };

                    // Serie y Correlativo
                    let GrcSerie = '';
                    let GrcCorrelative = '';
                    if (invoiceNumber.includes('-')) {
                        const parts = invoiceNumber.split('-');
                        GrcSerie = parts[0].trim().substring(0, 4).toUpperCase();
                        GrcCorrelative = parts[1].trim().substring(0, 8);
                    } else {
                        GrcSerie = '';
                        GrcCorrelative = invoiceNumber.trim().substring(0, 8);
                    }

                    this.xmlDataInvoice = xmlData;
                    this.invoiceForm.GrcSerie = GrcSerie;
                    this.invoiceForm.GrcCorrelative = GrcCorrelative;
                    if (documentTypeCode) {
                        this.invoiceForm.U_SYP_MDTD = documentTypeCode;
                    }
                    console.log('[XML parsed]', { documentTypeCode, invoiceNumber });
                } catch (error) {
                    console.log("Error al parsear XML:", error);
                    this.$fun.alert("Error al leer el archivo XML.", "error");
                }
            };
            reader.readAsText(file);
        },
        clearXMLFile() {
            this.xmlFileInvoice = null;
            this.pdfFileInvoice = null;
            this.xmlDataInvoice = { invoiceNumber: '', total: 0, currency: '', documentTypeCode: '', issuerRUC: '' };
            if (this.$refs.fileInputXML_invoice) this.$refs.fileInputXML_invoice.value = "";
            if (this.$refs.fileInputPDF_invoice) this.$refs.fileInputPDF_invoice.value = "";
        },
        handlePDFFileEvent(e) {
            const file = e.target.files[0];
            if (file) {
                this.pdfFileInvoice = file;
            }
        },
        clearPDFFile() {
            this.pdfFileInvoice = null;
            if (this.$refs.fileInputPDF_invoice) this.$refs.fileInputPDF_invoice.value = "";
        },
        handleServiceActFileEvent(e) {
            const file = e.target.files[0];
            if (file) {
                this.serviceActFile = file;
            }
        },
        clearServiceActFile() {
            this.serviceActFile = null;
            if (this.$refs.fileInputServiceAct) this.$refs.fileInputServiceAct.value = "";
        },
        confirmDisapproval() {
            console.log("Confirmando desaprobación con motivo:", this.conformityComment);
            this.$fun.alert(`Conformidad desaprobada. Motivo: ${this.conformityComment}`, "success");
        },
        getAttachmentTitle(index) {
            const config = {
                1: 'Cotización',
                2: 'Cuadro Comparativo',
                3: 'Guia de Remisión : PDF',
                4: 'Guia de Remisión : XML',
                5: 'Guia de Remisión : CDR',
                6: 'Acta de Conformidad (Servicios)',
                7: 'Factura Electronica : PDF',
                8: 'Factura Electronica : XML',
                9: 'Factura Electronica : CDR',
                10: 'Anexo Extra'
            };
            return config[index] || 'Documento';
        },
        downloadPortalFile(fileName) {
            console.log("Descargando", `${fileName}`);
            if (fileName) {
                _sGeneral.download(fileName, this.$fun.getUserID()).then((r) => {
                    this.$fun.download(r.data, fileName);
                });
            } else {
                this.$fun.alert("No hay ningún archivo cargado para descargar.", "warning");
            }
        },
        downloadFileSummary(fileName) {
            if (fileName) {
                const newfileName = fileName.split(/[\\/]/).pop();
                console.log("Descargando file Summary", `${newfileName}`);
                _sGeneral.download(newfileName, this.$fun.getUserID()).then((r) => {
                    this.$fun.download(r.data, newfileName);
                });
                // _GenUploadFiles.getFile("RutaAnexosSAP", `${fileName}`)
                //     .then(resp => console.log('downloaded : ', resp))
                //     .catch(error => console.error("Error al obtener imagen:", error));
            }
        },
        approvePortalFile(file) {
            const payload = {
                ...file,
                FilStatus: 2,
                UsrCreateID: this.$fun.getUserID()
            }
            console.log(JSON.parse(JSON.stringify(payload)));
            _sOrderPurchaseFile.updateFileStatusPortal(payload, this.$fun.getUserID()).then((r) => {
                if (r.status === 200) {
                    file.FilStatus = 2;
                    file.UsrCreateID = this.$fun.getUserID();
                    this.$emit('SavedInvoice');
                    this.$fun.alert(`Archivo de conformidad aprobado correctamente.`, "success");
                } else {
                    this.$fun.alert("No se pudo aprobar el archivo.", "error");
                }
            }).catch(() => {
                this.$fun.alert("No se pudo aprobar el archivo.", "error");
            });
        },
        toggleDisapprovePortalFile(file) {
            if (this.activeDisapprovalFileId === file.FilID) {
                this.activeDisapprovalFileId = null;
                this.disapprovalComment = '';
            } else {
                this.activeDisapprovalFileId = file.FilID;
                this.disapprovalComment = '';
            }
        },
        confirmPortalFileDisapproval(file) {
            const payload = {
                ...file,
                FilStatus: 3,
                FilObservation: this.disapprovalComment,
                UsrCreateID: this.$fun.getUserID()
            }

            console.log(JSON.parse(JSON.stringify(payload)));
            _sOrderPurchaseFile.updateFileStatusPortal(payload, this.$fun.getUserID()).then((r) => {
                if (r.status === 200) {
                    file.FilStatus = 3;
                    file.FilObservation = this.disapprovalComment;
                    file.UsrCreateID = this.$fun.getUserID();
                    this.activeDisapprovalFileId = null;
                    this.disapprovalComment = '';
                    this.$emit('SavedInvoice');
                    this.$fun.alert(`Archivo de conformidad desaprobado.`, "success");
                } else {
                    this.$fun.alert("No se pudo desaprobar el archivo.", "error");
                }
            }).catch(() => {
                this.$fun.alert("No se pudo desaprobar el archivo.", "error");
            });
        },
        async loadSelected(selectedField, targetProperty) {
            try {
                const response = await _sSaleOrder.list_selected({ selected: selectedField }, this.$fun.getUserID());
                if (response.status === 200 && response.data) {
                    this[targetProperty] = response.data;
                }
            } catch (error) {
                console.log(`Error al cargar ${selectedField}:`, error);
            }
        },
    },
    watch: {
        "orderLocal": {
            immediate: true,
            deep: true,
            handler(val) {
                console.log(JSON.parse(JSON.stringify({ val })));
                if (val != null) {
                    const filesApproved = this.orderLocal && this.orderLocal.PurchaseFiles ? this.orderLocal.PurchaseFiles.filter(file => file.FilStatus == 2) : [];
                    this.invoiceForm.U_SYP_BIESRVADQ = this.orderLocal.U_SYP_BIESRVADQ ? this.orderLocal.U_SYP_BIESRVADQ : "*";

                    if (this.orderLocal.TypeOrder == 1) {
                        this.invoiceForm.U_SYP_TCOMPRA = this.orderLocal.ClassOperationPurchaseName ? this.orderLocal.ClassOperationPurchaseName : "*";
                    }

                    if (this.orderLocal && this.orderLocal.U_SYP_ANEXO6 && filesApproved.find(x => x.AttachmentIndex == 6)) {
                        this.serviceActFile = { name: this.orderLocal.U_SYP_ANEXO6 };
                    }

                    console.log(JSON.parse(JSON.stringify((filesApproved))))
                    if (this.orderLocal && this.orderLocal.U_SYP_ANEXO7 && filesApproved.find(x => x.AttachmentIndex == 7)) {
                        this.pdfFileInvoice = { name: this.orderLocal.U_SYP_ANEXO7 };
                    }
                    if (this.orderLocal && this.orderLocal.U_SYP_ANEXO8 && filesApproved.find(x => x.AttachmentIndex == 8)) {
                        this.xmlFileInvoice = { name: this.orderLocal.U_SYP_ANEXO8 };
                    }
                    this.fetchOrderActivities();
                }
            }
        }
    },

    async created() {
        _sGenParam.search({ PrmName: "ValidateBudget" }, this.$fun.getUserID()).then(resp => {
            this.ValidateBudget = resp.data.PrmValue;
        });

        _sRequirement.goodservicelist(this.$fun.getUserID()).then(resp => {
            if (resp.status == 200) {
                this.goodServiceList = resp.data;
            }
        })
        await this.loadSelected('U_SYP_MDTD', 'paymentTypes');
    },
}

</script>

<style scoped>
.ios-tab-pane {
    animation: ios-pane-enter 0.28s ease;
}

@keyframes ios-pane-enter {
    from {
        opacity: 0;
        transform: translateY(6px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ══════════════════════════════════════════════════════════
   GRC — Entradas de Mercancía Panel  (dark gray + purple)
══════════════════════════════════════════════════════════ */

/* ── Header ───────────────────────────────────────────── */
.grc-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    padding: 6px 8px;
    background: linear-gradient(135deg, #04abc5 0%, #04abc5 100%);
    /* background: linear-gradient(90deg, rgba(108, 99, 255, 0.06) 0%, rgba(167, 139, 250, 0.04) 100%); */
    border-radius: 12px;
    border: 1px solid rgba(167, 139, 250, 0.18);
}

.grc-header-icon {
    background: rgba(255, 255, 255, 0.3);
    padding: 6px;
    border-radius: 10px;
    backdrop-filter: blur(10px);
}

.grc-header-left {
    display: flex;
    align-items: center;
    gap: 6px;
}

.grc-header-title {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: #FFF;
    letter-spacing: 0.3px;
}

.grc-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
}

.grc-selected-label {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 12px;
    color: #FFF;
}

.grc-col-table {
    /* flex: 1 1 0; */
    min-width: 0;
}

.grc-col-form {
    /* flex: 0 0 260px; */
    /* width: 260px; */
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid rgba(167, 139, 250, 0.15);
    padding: 16px 14px 18px;
    display: flex;
    flex-direction: column;
    gap: 0;
}

/* ── Table ────────────────────────────────────────────── */
.grc-table {
    border-radius: 12px !important;
    overflow: hidden;
    background: #ffffff !important;
    box-shadow: 0 2px 12px rgba(108, 99, 255, 0.08) !important;
}

.grc-table>>>thead th {
    background: #f5f3ff !important;
    color: #374151 !important;
    font-weight: 700 !important;
    font-size: 10px !important;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    border-bottom: 1px solid rgba(108, 99, 255, 0.12) !important;
}

.grc-table>>>tbody tr {
    background: #ffffff;
}

/* checkbox color override */
.grc-table>>>.v-data-table__checkbox .v-icon {
    color: #04abc5 !important;
}

.grc-desc-text {
    font-size: 12px;
    color: #374151;
    line-height: 1.4;
}

.grc-mono {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: #374151;
}

.grc-qty-chip {
    font-weight: 700 !important;
    min-width: 36px;
    justify-content: center;
}

.grc-qty-input>>>input {
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    color: #1F2937;
}

.grc-qty-input>>>.v-input__slot {
    background: #faf5ff !important;
    border-color: rgba(108, 99, 255, 0.25) !important;
}

.grc-qty-input.error--text>>>.v-input__slot {
    border-color: #EF4444 !important;
    background: #FEF2F2 !important;
}

.grc-total-text {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 700;
    color: #374151;
}

/* ── Right-panel form ─────────────────────────────────── */
.grc-form-title {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 11px;
    font-weight: 700;
    color: #04abc5 !important;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
}

.grc-field-wrap {
    margin-bottom: 10px;
}

.grc-row-inline {
    display: flex;
    gap: 8px;
}

.grc-field-half {
    flex: 1 1 0;
    min-width: 0;
}

.grc-input-label {
    display: block;
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 11px;
    font-weight: 600;
    color: #6B7280;
    letter-spacing: 0.3px;
    margin-bottom: 2px;
    padding-left: 2px;
}

/* Dark inputs inside the form panel */
.grc-col-form>>>.v-input__slot {
    background: #faf5ff !important;
    border-color: rgba(108, 99, 255, 0.22) !important;
    border-radius: 8px !important;
}

.grc-col-form>>>.v-label {
    color: #6B7280 !important;
    font-size: 12px;
}

.grc-col-form>>>input,
.grc-col-form>>>.v-select__selection {
    color: #1F2937 !important;
    font-size: 13px;
}

.grc-col-form>>>.v-input__control>>>.v-input__slot:hover {
    border-color: #a78bfa !important;
}

/* Total banner */
.grc-total-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 14px;
    padding: 10px 12px;
    background: linear-gradient(135deg, rgba(108, 99, 255, 0.08), rgba(167, 139, 250, 0.12));
    border-radius: 10px;
    border: 1px solid rgba(167, 139, 250, 0.20);
}

.grc-total-banner-label {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 11px;
    color: #4B5563;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.grc-total-banner-value {
    font-family: 'Roboto Mono', monospace;
    font-size: 15px;
    font-weight: 700;
    color: #1F2937;
}

/* Save button */
.grc-save-btn {
    font-weight: 700 !important;
    letter-spacing: 1px !important;
    text-transform: none !important;
    background: linear-gradient(135deg, #2ccbe3, #04abc5) !important;
    box-shadow: 0 4px 14px rgba(124, 58, 237, 0.40) !important;
    transition: transform 0.15s ease, box-shadow 0.15s ease !important;
}

.grc-save-btn:not(.v-btn--disabled):hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 20px rgba(124, 58, 237, 0.55) !important;
}

.product-cell {
    display: flex;
    flex-direction: column;
    padding: 4px 0;
}

.product-code {
    font-family: 'Consolas', monospace;
    font-size: 12px;
    font-weight: 700;
    color: #0f172a;
    align-self: flex-start;
}

.product-desc {
    font-size: 12px;
    color: #64748b;
}

/* Componentes Visuales Breves (Badges) */
.whs-badge {
    background: #f1f5f9;
    color: #334155;
    font-size: 11px;
    font-weight: 600;
    padding: 3px 8px;
    border-radius: 4px;
    border: 1px solid #e2e8f0;
}

.qty-value {
    font-size: 13px;
    font-weight: 700;
    color: #0f172a;
}

.qty-unit {
    font-size: 10px;
    color: #94a3b8;
    text-transform: uppercase;
}

.currency-value {
    font-size: 12px;
    color: #334155;
}

/* Resalte de la columna de Dinero Real Tangible */
.total-highlight {
    font-size: 13px;
    font-weight: 700;
    color: #0284c7;
    /* Azul corporativo */
}

/* Badges de Estado estilo Minimalista */
.status-c {
    background-color: #e2fbe8;
    color: #1e7e34;
}

.status-o {
    background-color: #fff3cd;
    color: #856404;
}

/* ── Responsive ────────────────────────────────────────── */
@media (max-width: 768px) {
    /* .grc-body {
        flex-direction: column;
    } */
}

.grc-chip-currency {
    background: linear-gradient(135deg, #6C63FF 0%, #a78bfa 100%) !important;
    color: #fff !important;
    font-weight: 700;
    font-size: 10px !important;
    letter-spacing: 0.5px;
}

.grc-total-pill {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    background: linear-gradient(135deg, #6C63FF, #a78bfa);
    padding: 3px 14px;
    border-radius: 20px;
    box-shadow: 0 2px 8px rgba(108, 99, 255, 0.28);
    letter-spacing: 0.2px;
}

/* ── Items Table ──────────────────────────── */
.grc-table {
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 2px 12px rgba(108, 99, 255, 0.07) !important;
}

.grc-table>>>thead th {
    background: linear-gradient(90deg, #f0eeff, #f5f3ff) !important;
    color: #5B4FC9 !important;
    font-weight: 700 !important;
    font-size: 11px !important;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

.grc-table>>>tbody tr:hover {
    background: rgba(108, 99, 255, 0.04) !important;
}

.grc-table>>>tbody tr.v-data-table__selected {
    background: rgba(108, 99, 255, 0.09) !important;
}

.grc-desc-text {
    font-size: 12px;
    color: #374151;
    line-height: 1.4;
}

.grc-mono {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 600;
    color: #1F2937;
}

.grc-qty-chip {
    font-weight: 700 !important;
    min-width: 38px;
    justify-content: center;
}

.grc-qty-input>>>input {
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    color: #374151;
}

.grc-qty-input.error--text>>>.v-input__slot {
    border-color: #EF4444 !important;
    background: #FEF2F2 !important;
}

.grc-total-text {
    font-family: 'Roboto Mono', monospace;
    font-size: 12px;
    font-weight: 700;
    color: #4338CA;
}

/* ── Form Section ──────────────────────────── */
.grc-form-section {
    margin-top: 20px;
    padding: 16px;
    background: rgba(255, 255, 255, 0.85);
    border-radius: 14px;
    border: 1px solid rgba(108, 99, 255, 0.10);
    box-shadow: 0 1px 6px rgba(108, 99, 255, 0.06);
}

.grc-form-title {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 700;
    color: #6C63FF;
    text-transform: uppercase;
    letter-spacing: 0.7px;
    display: flex;
    align-items: center;
}

.grc-field>>>.v-input__slot {
    border-radius: 8px !important;
}

/* ── Responsive ────────────────────────────── */
@media (max-width: 600px) {
    .grc-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .grc-total-pill {
        align-self: flex-end;
    }

    .grc-form-section {
        padding: 12px 10px;
    }
}

/* ── Document Upload Stack ─────────────────────────────── */
.doc-upload-stack {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
}

.doc-upload-card {
    position: relative;
    display: flex;
    align-items: center;
    width: 100%;
    padding: 11px 14px 11px 8px;
    border-radius: 12px;
    border: 1.5px dashed #d1d9e6;
    background: #f9fbff;
    cursor: pointer;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    text-decoration: none;
}

.doc-upload-card:hover {
    border-style: solid;
    background: #f0f5ff;
    transform: translateY(-1px);
    box-shadow: 0 6px 18px rgba(30, 64, 175, 0.07);
}

/* Loaded state — when a file is selected */
.doc-upload-card.loaded {
    border-style: solid;
    background: #ffffff;
}

/* Left accent stripe */
.doc-card-stripe {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    border-radius: 12px 0 0 12px;
}

.xml-stripe {
    background: linear-gradient(180deg, #16a34a 0%, #4ade80 100%);
}

.pdf-stripe {
    background: linear-gradient(180deg, #dc2626 0%, #f87171 100%);
}

/* Color themes per card type */
.xml-card {
    border-color: #bbf7d0;
}

.xml-card:hover {
    border-color: #22c55e;
}

.xml-card.loaded {
    border-color: #86efac;
    box-shadow: 0 4px 14px rgba(34, 197, 94, 0.10);
}

.xml-card .doc-card-icon {
    color: #16a34a;
}

.pdf-card {
    border-color: #fecaca;
}

.pdf-card:hover {
    border-color: #ef4444;
}

.pdf-card.loaded {
    border-color: #fca5a5;
    box-shadow: 0 4px 14px rgba(239, 68, 68, 0.10);
}

.pdf-card .doc-card-icon {
    color: #dc2626;
}

/* Icon column */
.doc-card-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: rgba(248, 250, 255, 0.9);
    margin-left: 8px;
    margin-right: 12px;
    flex-shrink: 0;
    transition: background 0.2s ease;
}

.xml-card .doc-card-icon {
    background: rgba(34, 197, 94, 0.08);
}

.pdf-card .doc-card-icon {
    background: rgba(239, 68, 68, 0.08);
}

/* Text body */
.doc-card-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 0;
}

.doc-card-label {
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #94a3b8;
    margin-bottom: 2px;
}

.doc-card-name {
    font-size: 0.78rem;
    font-weight: 600;
    color: #334155;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

/* Right side — badge / status */
.doc-card-right {
    display: flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    margin-left: 8px;
}

.doc-card-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.6rem;
    font-weight: 800;
    letter-spacing: 0.8px;
    padding: 2px 8px;
    border-radius: 20px;
}

.xml-badge {
    background: rgba(34, 197, 94, 0.12);
    color: #16a34a;
    border: 1px solid #bbf7d0;
}

.pdf-badge {
    background: rgba(239, 68, 68, 0.10);
    color: #dc2626;
    border: 1px solid #fecaca;
}

.service-stripe {
    background: linear-gradient(180deg, #3b82f6 0%, #60a5fa 100%);
}

.service-card {
    border-color: #bfdbfe;
}

.service-card:hover {
    border-color: #3b82f6;
}

.service-card.loaded {
    border-color: #93c5fd;
    box-shadow: 0 4px 14px rgba(59, 130, 246, 0.10);
}

.service-card .doc-card-icon {
    color: #2563eb;
    background: rgba(37, 99, 235, 0.08);
}

.service-badge {
    background: rgba(59, 130, 246, 0.12);
    color: #2563eb;
    border: 1px solid #bfdbfe;
}

.doc-card-success {
    display: flex;
    align-items: center;
    gap: 2px;
}

.doc-delete-btn {
    background: rgba(241, 245, 249, 0.9) !important;
    color: #94a3b8 !important;
    transition: all 0.15s ease;
}

.doc-delete-btn:hover {
    background: rgba(239, 68, 68, 0.12) !important;
    color: #dc2626 !important;
}

/* Slide-down transition for PDF card */
.slide-down-enter-active {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-down-leave-active {
    transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
}

.slide-down-enter,
.slide-down-leave-to {
    opacity: 0;
    transform: translateY(-8px);
}

.truncate-text {
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── SAP Canceled Banner ── */
.sap-canceled-banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 28px 20px;
    height: 100%;
    min-height: 280px;
    border-radius: 1.5rem;
    background: linear-gradient(145deg, #fff5f5 0%, #fef2f2 60%, #fff0f0 100%);
    border: 1.5px solid rgba(239, 68, 68, 0.22);
    box-shadow: 0 4px 20px rgba(239, 68, 68, 0.09), inset 0 1px 0 rgba(255, 255, 255, 0.8);
    position: relative;
    overflow: hidden;
}

.sap-canceled-banner::before {
    content: '';
    position: absolute;
    top: -30px;
    right: -30px;
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(239, 68, 68, 0.18) 0%, transparent 70%);
    pointer-events: none;
}

.sap-canceled-icon-wrap {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(239, 68, 68, 0.15);
    border: 2px solid rgba(239, 68, 68, 0.4);
    margin-bottom: 16px;
    animation: sap-pulse 2.5s ease-in-out infinite;
}

@keyframes sap-pulse {

    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.3);
    }

    50% {
        box-shadow: 0 0 0 10px rgba(239, 68, 68, 0);
    }
}

.sap-canceled-title {
    font-size: 1rem;
    font-weight: 700;
    color: #dc2626;
    letter-spacing: 0.03em;
    margin-bottom: 10px;
    text-transform: uppercase;
}

.sap-canceled-subtitle {
    font-size: 0.8rem;
    color: #6b7280;
    line-height: 1.55;
    margin-bottom: 16px;
}

.sap-canceled-subtitle strong {
    color: #b91c1c;
}

.portal-docs-section {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
}

.portal-docs-header {
    display: flex;
    align-items: center;
}

.portal-docs-title {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 11px;
    font-weight: 700;
    color: #475569;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.portal-docs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 12px;
}

.portal-doc-card {
    background: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 4px 6px;
    transition: all 0.2s ease;
}

.portal-doc-card:hover {
    border-color: #cbd5e1;
    background: #f1f5f9;
}

.portal-doc-main {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.portal-doc-info {
    flex-grow: 1;
    min-width: 0;
    padding-right: 8px;
}

.portal-doc-type {
    font-size: 10px;
    font-weight: 700;
    color: #0f172a;
    text-transform: uppercase;
}

.portal-doc-name {
    font-size: 11px;
    color: #64748b;
    margin-top: 1px;
}

.portal-doc-actions-status {
    display: flex;
    align-items: center;
    flex-shrink: 0;
}

.portal-doc-observation {
    font-size: 10.5px;
    color: #b91c1c;
    background: #fef2f2;
    border-left: 3px solid #ef4444;
    padding: 4px 6px;
    border-radius: 0 4px 4px 0;
}

.portal-doc-disapprove-input {
    border-top: 1px dashed #cbd5e1;
    padding-top: 8px;
}

.conformity-icon-btn {
    transition: transform 0.2s ease, color 0.2s ease !important;
}

.conformity-icon-btn:hover {
    transform: scale(1.15);
}

.conformity-textarea {
    margin-top: 4px;
}

.conformity-textarea>>>.v-input__slot {
    background: #fcfcfc !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 8px !important;
}

.conformity-textarea>>>textarea {
    font-size: 12px;
    color: #334155;
}

.portal-doc-feedback-msg {
    font-size: 11px;
    font-family: 'Inter', 'Roboto', sans-serif;
}

.approved-feedback-wrap {
    background-color: #f0fdf4;
    border: 1px solid #bbf7d0;
    color: #16a34a;
    padding: 6px 10px;
    border-radius: 6px;
}

.rejected-feedback-wrap {
    background-color: #fef2f2;
    border: 1px solid #fecaca;
    color: #dc2626;
    padding: 6px 10px;
    border-radius: 6px;
}

.feedback-text {
    font-size: 11px;
    line-height: 1.4;
}

.inner-detail-td {
    background-color: #f8fafc !important;
}

.inner-detail-table {
    border: 1px solid #e2e8f0 !important;
    border-radius: 8px;
    background-color: #ffffff !important;
}

.grc-table>>>thead th {
    height: 38px !important;
    padding: 0 12px !important;
}
</style>